import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const EditAction = ({ onClick, disabled, loading }) => (
  <RibbonMenu
    className="aridhia-edit-action"
    disabled={disabled}
    icon="pencil"
    loading={loading}
    message="actions.edit"
    name="edit"
    onClick={onClick}
  />
);

export default EditAction;
